<template>
  <div>
    <vue-headful title="Verdiensten" />
    <Header page_title="Verdiensten" />
    <div class="px-4 mx-2 pb-4 mt-4">
      <form @change="onFormChange" @submit.prevent="onSubmit" class="sd-form">
        <div class="container-fluid px-0 pb-1 mb-2">
          <NotificationContainer />
          <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="suitcase" /> Verdiensten</span></strong>
          <div class="sd-notif warning sd-alert" v-if="formDisabled">
            <svg-icon icon="information" class="warning-icon" />
            <div class="content">
              Je kunt hier zelf geen aanpassingen doen. Neem contact met ons op om veranderingen door te geven. <a href="mailto:info@derect.nl">info@derect.nl</a>.
              <div v-if="type == 0 && sub_branch !== '2'">
                Je kunt wel aanpassen of je loonheffingskorting wil toepassen of
                niet.
              </div>
            </div>
          </div>

          <div class="sd-custom worker-type custom-control custom-radio mt-3">
            <input
              type="radio"
              class="custom-control-input"
              id="temp_worker"
              value="0"
              v-model="type"
              :disabled="formDisabled"
            />
            <label for="temp_worker" class="custom-control-label"
              >Ik ben uitzendkracht</label
            >
          </div>
          <div class="sd-custom worker-type custom-control custom-radio">
            <input
              type="radio"
              class="custom-control-input"
              id="zzp"
              value="1"
              v-model="type"
              :disabled="formDisabled"
            />
            <label for="zzp" class="custom-control-label">Ik ben zzp'er</label>
          </div>

          <div class="sd-notif warning">
            <svg-icon icon="information" class="warning-icon" />
            Je ontvangt een reiskostenvergoeding van deur tot deur van €0,21 per
            kilometer.
          </div>
          <div v-if="type === '1' && branch == 1" class="sd-notif warning">
            <svg-icon icon="information" class="warning-icon"/>
            Voor de facturatie aan Derect dien je vrijgesteld te zijn van btw.
            Ben je dat (nog) niet, neem dan contact met ons op.
          </div>

          <div class="temp_worker" v-if="type === '0'">
            <div>
              <div class="mb-3" style="margin-top: 1.5rem !important">
                <p>
                  <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="wallet" /> Kies hier je salaris/tarief</span></strong>
                </p>
              </div>

              <div class="mb-4">
                  <template v-if="this.branch !== '3'">
                        <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()" v-if="this.branch == 1">
                          <label>Schaal</label>
                          <select
                            class="custom-select form-control"
                            v-model="form_salary.salary_id"
                            required
                            :disabled="formDisabled"
                          >
                            <option value selected disabled>Schaal</option>
                            <option
                              v-for="option in this.salaries_temp"
                              :key="option.id"
                              :value="option.id"
                              :selected="option.id === form_salary.salary_id"
                            >
                                {{ option.name }}
                            </option>
                          </select>
                          <div class="icon-wrapper dropdown position-absolute align-self-center">
                            <svg-icon icon="chevron_s" />
                          </div>
                        </div>

                        <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                          <label>Tarief (excl. BTW)</label>
                          <select
                            class="custom-select form-control"
                            v-model="form_salary.salary_per_hour"
                            required
                            :disabled="!this.raw_salaries ? 'disabled' : formDisabled"
                          >
                            <option selected value="0.00" disabled>
                                Tarief (Kies eerst een Schaal!)
                            </option>
                              <option
                                  v-for="salary in raw_salaries"
                                  :value="salary.toFixed(2)"
                                  v-bind:key="salary"
                              >
                                  € {{ salary.toFixed(2).replace('.', ',') }}
                              </option>
                          </select>
                          <div class="icon-wrapper dropdown position-absolute align-self-center ">
                            <svg-icon icon="chevron_s" />
                          </div>
                        </div>
                  </template>
                  <template v-else>
                      <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                          <label>Salaris</label>
                          <input
                              type="text"
                              class="form-control"
                              placeholder="EUR / uur"
                              v-model="salary_per_hour"
                              inputmode="decimal"
                              autocomplete="off"
                              @input="onSalaryInput"
                              @paste="onSalaryPaste"
                              :disabled="formDisabled"
                              required
                          />
                      </div>
                  </template>
              </div>

              <template v-if="sub_branch !== '2'">
                <div class="mb-3">
                  <p>
                    <strong class="sd-title mini right-line">
                        <span class="title-text"><svg-icon icon="creditcard" /> Jouw rekeningnummer</span>
                    </strong>
                  </p>
                </div>

                <div class="form-group sd-input mb-4">
                  <label>De tenaamstelling van je rekening</label>
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                      this.required.includes('account_name') ? 'require' : ''
                    ]"
                    v-bind:placeholder="
                      'De tenaamstelling van je rekening' +
                        [this.required.includes('account_name') ? ' *' : '']
                    "
                    v-model="form_temp.account_name"
                    @input="forceUpper($event, form, 'account_name')"
                    required
                  />
                </div>
                <div class="form-group mb-4 sd-input mb-4">
                  <label>IBAN</label>
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                      this.required.includes('account_number') ? 'require' : ''
                    ]"
                    v-bind:placeholder="
                      'IBAN' +
                        [this.required.includes('account_number') ? ' *' : '']
                    "
                    v-model="form_temp.account_number"
                    v-mask="'AA##AAAA##########'"
                    @input="forceUpper($event, form, 'account_number')"
                    required
                  />
                  <span class="extra-info" style="margin-bottom: 15px;">
                    <svg-icon icon="information" />
                    IBAN formaat: NL99BANK0123456789 (gebruik géén spaties)
                  </span>
                </div>
              </template>
            </div>
            <template v-if="sub_branch !== '2'">
              <div class="mb-3">
                <p>
                  <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="discount" /> Loonheffingskorting</span></strong>
                </p>
              </div>
              <div class="mb-4 position-relative">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch1"
                    v-model="form_temp.income_tax"
                    v-bind:true-value="1"
                    v-bind:false-value="0"
                  />
                  <label class="custom-control-label apply-deduction" for="customSwitch1"
                    >Wil je loonheffingskorting toepassen?</label
                  >
                </div>
                <a
                  data-toggle="collapse"
                  href="#collapseExample"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  <i class="material-icons-round">help</i>
                </a>
                <div class="collapse" id="collapseExample">
                  <div class="alert alert-info mt-3 mb-1" role="alert">
                    <div class="small text-left">
                      Je kunt maar bij één werkgever de heffingskorting toepassen.
                      Doe dit bij de werkgever waar je het meest verdient. Als je
                      bij iedere werkgever loonheffingskorting aanvraagt, krijg je
                      namelijk te veel korting op je belasting. Je moet dan
                      achteraf extra belasting betalen.
                    </div>
                  </div>
                </div>
                <div class="sd-notif warning" v-if="formDisabled">
                  <svg-icon icon="information" class="warning-icon" />
                  Ook als je al een salaris hebt doorgegeven kun je de
                  loonheffingskorting aanpassen.
                </div>
              </div>
            </template>
            <!-- <Required v-if="user" /> -->
            <button type="submit" class="btn btn-warning btn-block">
              Opslaan
            </button>
          </div>

          <div class="zzp" v-if="type === '1'">
            <template v-if="sub_branch !== '2'">
              <div class="mb-3">
                <p>
                  <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="office" /> Bedrijfsgegevens</span></strong>
                </p>
              </div>
              <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                <!--              <label>Bedrijfs type</label>-->
                <select
                    class="custom-select form-control"
                    v-model="form_kvk.legalform"
                    required
                    :disabled="formDisabled"
                >
                  <option disabled value="">Selecteer één</option>
                  <option>eenmanszaak</option>
                  <option>VOF</option>
                  <option>BV</option>
                </select>
                <div class="icon-wrapper dropdown position-absolute align-self-center ">
                  <svg-icon icon="chevron_s" />
                </div>
              </div>
              <div class="form-group sd-input mb-4">
                <label>Tenaamstelling onderneming</label>
                <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                    v-bind:placeholder="
                  'Tenaamstelling onderneming' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                    v-model="form_kvk.company_name"
                    @input="forceUpper($event, form, 'account_name')"
                    required
                    :disabled="formDisabled"
                />
                <small class="form-text text-muted">
                  Let op: de tenaamstelling kan geen leestekens bevatten
                </small>
              </div>
              <div class="form-group sd-input mb-4">
                <label>KVK-nummer</label>
                <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                    v-bind:placeholder="
                  'KVK-nummer' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                    v-model="form_kvk.kvk"
                    @input="forceUpper($event, form, 'account_name')"
                    required
                    :disabled="formDisabled"
                />
              </div>
              <div class="form-group mb-4 pb-1 sd-input mb-4">
                <label>BTW-nummer</label>
                <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                    v-bind:placeholder="
                  'BTW-nummer' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                    v-model="form_kvk.btw"
                    @input="forceUpper($event, form, 'account_name')"
                    required
                    :disabled="formDisabled"
                />
              </div>
            </template>

            <div class="mb-3">
              <p>
                <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="wallet" /> Uurtarief</span></strong>
              </p>
            </div>

            <div class="mb-4">
                <template v-if="this.branch !== '3'">
                      <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                        <label>ZZP</label>
                        <select
                          class="custom-select form-control"
                          v-model="form_salary.salary_id"
                          required
                          :disabled="formDisabled"
                        >
                          <option v-if="this.branch == 1" :key="3" :value="3" selected>ZZP</option>
                          <option v-if="this.branch == 2" :key="14" :value="14" selected>ZZP</option>
                        </select>
                        <div
                          class="icon-wrapper dropdown position-absolute align-self-center"
                        >
                          <svg-icon icon="chevron_s" />
                        </div>
                      </div>
                      <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                        <label>Tarief (excl. BTW)</label>
                        <select
                          class="custom-select form-control"
                          v-model="form_salary.salary_per_hour"
                          required
                          :disabled="formDisabled"
                        >
                          <option
                              selected
                              value="0.00"
                              disabled
                            >Tarief (excl. BTW)</option
                          >
                          <option
                            v-for="salary in raw_salaries"
                            :value="salary.toFixed(2)"
                            v-bind:key="salary"
                            >
                              € {{ salary.toFixed(2).replace('.', ',') }}
                          </option>
                        </select>
                        <div
                          class="icon-wrapper dropdown position-absolute align-self-center"
                        >
                          <svg-icon icon="chevron_s" />
                        </div>
                      </div>
                </template>
                <template v-else>
                    <div :class="'form-group w-square-icon sd-input mb-4 ' + getDisabledClass()">
                        <label>Salaris</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="EUR / uur"
                            v-model="salary_per_hour"
                            inputmode="decimal"
                            autocomplete="off"
                            @input="onSalaryInput"
                            @paste="onSalaryPaste"
                            :disabled="formDisabled"
                            required
                        />
                    </div>
                </template>
            </div>
            <template v-if="sub_branch !== '2'">
              <div class="mb-3">
                <p>
                  <strong class="sd-title mini right-line"><span class="title-text"><svg-icon icon="creditcard" /> Jouw rekeningnummer</span></strong>
                </p>
              </div>

              <div class="form-group sd-input mb-4">
                <label>De tenaamstelling van je rekening</label>
                <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                  this.required.includes('account_name') ? 'require' : ''
                ]"
                    v-bind:placeholder="
                  'De tenaamstelling van je rekening' +
                    [this.required.includes('account_name') ? ' *' : '']
                "
                    v-model="form_kvk.account_name"
                    @input="forceUpper($event, form, 'account_name')"
                    required
                />
              </div>
              <div class="form-group sd-input mb-4">
                <label>IBAN</label>
                <input
                    type="text"
                    class="form-control"
                    v-bind:class="[
                  this.required.includes('account_number') ? 'require' : ''
                ]"
                    v-bind:placeholder="
                  'IBAN' +
                    [this.required.includes('account_number') ? ' *' : '']
                "
                    v-model="form_kvk.account_number"
                    v-mask="'AA##AAAA##########'"
                    @input="forceUpper($event, form, 'account_number')"
                    required
                />
                <small class="form-text text-muted">
                  IBAN formaat: NL99BANK0123456789 (gebruik géén spaties)
                </small>
              </div>
            </template>

            <button
              type="submit"
              class="btn btn-warning btn-block"
            >
              Opslaan
            </button>
          </div>
        </div>
      </form>
    </div>
  <Footer />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      branch: 0,
      sub_branch: '1',
      user: "",
      type: "",
      salaries_temp: null,
      form: {
        account_name: "",
        account_number: "",
        income_tax: 0
      },
      form_temp: {
        customer_type: 0,
        account_name: "",
        account_number: "",
        income_tax: 0
      },
      form_kvk: {
        customer_type: 1,
        legalform: "",
        kvk: "",
        btw: "",
        company_name: "",
        account_name: "",
        account_number: ""
      },
      form_salary: {
        salary_id: "",
        years_experience: "",
        salary_per_hour: null
      },
      salary_display: "EUR / uur",
      salary_display_vo: "EUR / uur",
      required: "",
      formDisabled: false,
      prevRoute: null,
      salaries: null,
      raw_salaries: null,
      salaries_arr: null,
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    form_salary: {
      immediate: true,
      handler: function() {
        if (this.form_salary.salary_id && this.branch !== '3') {
          this.computeSalary();
        } else if (this.branch === '3') {

        }
      },
      deep: true
    }
  },
    computed: {
        salary_per_hour: {
            get() {
                const v = this.form_salary && this.form_salary.salary_per_hour;
                const n = (v === null || v === undefined) ? NaN : Number(String(v).replace(',', '.'));

                if (v === '' || v === null || v === undefined) return '';
                if (!isNaN(n) && n === 0) return '';

                return v;
            },
            set(val) {
                if (!this.form_salary) this.form_salary = {};

                if (val === '' || val === null || val === undefined) {
                    this.form_salary.salary_per_hour = null;
                    return;
                }

                this.form_salary.salary_per_hour = val;
            }
        }
    },

  methods: {
      sanitizePrice(raw) {
          if (raw === null || raw === undefined) return '';
          let s = String(raw).replace(/[^0-9.,]/g, '');

          const lastComma = s.lastIndexOf(',');
          const lastDot = s.lastIndexOf('.');
          const lastSepIndex = Math.max(lastComma, lastDot);

          if (lastSepIndex !== -1) {
              const intPart = s.slice(0, lastSepIndex).replace(/[.,]/g, '');
              const decPart = s.slice(lastSepIndex + 1).replace(/[.,]/g, '');
              s = intPart + ',' + decPart;
          } else {
              s = s.replace(/[.,]/g, '');
          }

          if (s.includes(',')) {
              const [i, d] = s.split(',');
              s = i + ',' + (d || '').slice(0, 2);
          }
          s = s.replace(/^0+(?=\d)/, '');
          if (s.startsWith(',')) s = '0' + s;

          return s;
      },

      onSalaryInput(e) {
          const cleaned = this.sanitizePrice(e.target.value);
          e.target.value = cleaned;
          this.salary_per_hour = cleaned;
      },

      onSalaryPaste(e) {
          requestAnimationFrame(() => {
              const cleaned = this.sanitizePrice(e.target.value);
              e.target.value = cleaned;
              this.salary_per_hour = cleaned;
          });
      },
    forceUpper(e, obj, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(obj, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },
    async fetchData() {
      this.$store.state.loading = true;
      this.branch = localStorage.getItem("branch");
      this.sub_branch = localStorage.getItem("subBranch");
      this.user = JSON.parse(localStorage.getItem("user"));
      this.required = this.$store.state.applicant_fields;
      this.formDisabled =
        !((typeof this.user.account_name === "undefined" ||
            this.user.account_name === null ||
            this.user.account_name === "" ) &&
            (typeof this.user.years_experience === 'undefined' ||
            this.user.years_experience === null ||
            this.user.years_experience === 0));
      this.salaries_temp = await this.getAPIList("salaries/" + this.branch);
      await this.autoFillForm();
        if (this.form_salary.salary_id && this.branch !== '3') {
            await this.computeSalary();
        }
      this.$store.state.loading = false;
    },

    async autoFillForm() {
      return new Promise(resolve => {
        var obj;
        // const user = JSON.parse(localStorage.getItem("user"));
        // update the form obj from user
        if (this.user.customer_type === 0) {
          this.type = "0";
          for (obj in this.form_temp) {
            if (this.user[obj]) {
                console.log("Auto-filling form_temp with user data:", obj, this.user[obj]);
              this.form_temp[obj] = this.user[obj];
            }
          }
        } else {
          this.type = "1";
          for (obj in this.form_kvk) {
            if (this.user[obj]) {
              this.form_kvk[obj] = this.user[obj];
            }
          }
        }

        for (obj in this.form) {
          if (this.user[obj]) {
            this.form[obj] = this.user[obj];
          }
        }
        for (obj in this.form_salary) {
            console.log("Auto-filling form_salary with user data:", obj, Number(this.user[obj]));
          if (this.user[obj]) {
              this.form_salary[obj] = Number(this.user[obj]);
          }
        }
        resolve();
      });
    },
    async updateUser() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant";
        let formData = new FormData();
        var obj;
        if (this.type === "0") {
          for (obj in this.form_temp) {
            formData.append(obj, this.form_temp[obj]);
          }
        } else {
          for (obj in this.form_kvk) {
            formData.append(obj, this.form_kvk[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            if (this.formDisabled === true) {
              localStorage.removeItem("form-pending");
              const notification = {
                type: "success",
                message: "Je hebt je gegevens succesvol aangepast. "
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              this.$store.state.loading = false;
            }
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async updateSalary() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/salary";
        let formData = new FormData();

        // When branch is '3', only send the manual salary and skip id/years to avoid 422
        if (this.branch == 3 || this.branch === '3') {
          let val = this.form_salary.salary_per_hour;
          // Client-side validation for manual salary input
          if (val === null || val === undefined || val === '') {
            const notification = {
              type: 'danger',
              message: 'Vul je uurloon in om door te gaan.'
            };
            this.$store.dispatch('notification/replace', notification, { root: true });
            this.$store.state.loading = false;
            return reject(new Error('Missing salary_per_hour'));
          }
          // Normalize comma to dot and strip spaces
          val = val.toString().replace(',', '.').trim();
          // Ensure it is a number-like string
          if (isNaN(Number(val))) {
            const notification = {
              type: 'danger',
              message: 'Ongeldige invoer voor uurloon. Gebruik alleen cijfers en eventueel een komma of punt.'
            };
            this.$store.dispatch('notification/replace', notification, { root: true });
            this.$store.state.loading = false;
            return reject(new Error('Invalid salary_per_hour value'));
          }
          // Backend requires these fields as required; send neutral placeholders
          formData.append('salary_id', '0');
          formData.append('years_experience', '0');
          formData.append('salary_per_hour', val);
        } else {
            let salaryField = this.form_salary && this.form_salary['salary_per_hour'];
            let rawValue = (salaryField && typeof salaryField === 'object')
                ? salaryField.value
                : salaryField;

            let rawNumber = parseFloat(rawValue);
            let year = this.salaries_arr.find(item => item.salary === rawNumber).years;

            formData.append('salary_per_hour', rawValue);
            formData.append('salary_id', this.form_salary.salary_id);
            formData.append('years_experience', year);
        }

        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            localStorage.removeItem("form-pending");
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject(new Error('Salary update failed'));
          });
      });
    },
    async redirectBack() {
      return new Promise(() => {
        setTimeout(
          () =>
            this.$router.replace({
              name: this.prevRoute.name,
              params: this.prevRoute.params
            }),
          800
        );
      });
    },
    async onSubmit() {
      if (this.formDisabled === false) {
        this.$store.state.loading = true;
        window.scrollTo(0, 0);
        await this.updateUser();
        await this.updateSalary();
        // continue only if resolve()
        await this.updateLocalUser();
        await this.redirectBack();
        this.$store.state.loading = false;
      } else {
        this.$store.state.loading = true;
        window.scrollTo(0, 0);
        await this.updateUser();
        // continue only if resolve()
        await this.updateLocalUser();
        await this.redirectBack();
        this.$store.state.loading = false;
      }
    },
    async computeSalary() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/salary/compute";
        let formData = new FormData();

        formData.append("years", this.form_salary.years_experience);
        formData.append("salary_id", this.form_salary.salary_id);

        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            const salaries = resp.data.salary.tiers;
            this.salaries_arr = salaries;
            this.raw_salaries = salaries.map(item => item.salary);
            console.log(this.raw_salaries);
              resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject(new Error('Compute salary failed'));
          });
      });
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));

      if (this.type === "1") {
        if (this.branch == 1) {
          this.form_salary.salary_id = 3;
        } else {
          this.form_salary.salary_id = 14;
        }
      } else {
          if (this.form_salary.salary_id != 4 && this.form_salary.salary_id != 5) {
              this.form_salary.salary_id = "";
              this.raw_salaries = null;
          }
      }
    },
    getDisabledClass() {
      return this.formDisabled ? "form-disabled" : "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped>
.form-control[readonly] {
  background: #f5f4f4;
  opacity: 1;
}

.subbranch {
  font-weight: 500;
}

select[disabled] {
  opacity: 1;
}

.form-disabled {
  opacity: 0.5;
}

.custom-control-label.apply-deduction {
  display: inline-flex;
}

.custom-control-label.apply-deduction::before {
  margin-right: 10px;
}

.custom-checkbox .custom-control-label::before {
  top: 3px;
}
.custom-checkbox .custom-control-label::after {
  top: 3px;
}

.custom-switch + a {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

a.toggle-info {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: red;
}

.custom-switch + a i.material-icons-round {
  color: #FFCD00;
}
.custom-switch + a[aria-expanded="true"] i.material-icons-round {
  color: #c0bdbb;
}
</style>
